<template>
  <Teleport to="body">
    <transition name="notification-slide">
      <div v-if="modelValue" :class="$style.toast">
        <slot>
          <div v-if="icon" :class="$style.toast__icon">
            <component :is="icon"></component>
          </div>
          <div :class="$style.toast__content">
            <p :class="$style.toast__title" v-html="title" />
            <span :class="$style.toast__msg" v-html="message" />
          </div>
        </slot>
        <svgo-close :class="$style.close" @click="$emit('close')" />
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
defineEmits(['open', 'close']);

defineProps({
  title: {
    type: String,
    default: null,
  },
  message: {
    type: String,
    default: null,
  },
  icon: {
    type: [Object, String],
    default: null,
  },
});

defineModel('modelValue', {
  type: Boolean,
  default: false,
});

function open() {
  modelValue = true;
  emit('open');
}

function close() {
  modelValue = false;
  emit('close');
}

defineExpose({
  open,
  close,
});
</script>

<style lang="scss" module>
@use '@styles/setup/variables' as *;
@use '@styles/setup/mixins' as *;
.toast {
  position: fixed;
  top: 8px;
  left: 0;
  width: calc(100% - 16px);
  padding: 12px;
  margin: 0 8px;
  border-radius: 16px;
  background: $color-white;
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-column-gap: 12px;
  z-index: 999;

  @include tablet {
    top: 16px;
    margin: 0 auto;
    width: auto;
    max-width: 435px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &__icon {
    width: 18px;
    height: 18px;
    margin: 2px;
  }

  &__content {
  }

  &__title {
    font-size: 17px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.035em;
    margin-bottom: 4px;
  }

  &__msg {
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.03em;
    color: $color-black-56;
  }

  .close {
    width: 18px;
    height: 18px;
    margin: 2px;
    fill: $color-black-28;
    cursor: pointer;
    transition: fill 0.3s;

    &:hover {
      fill: $color-black-56;
    }
  }
}
</style>
